import React from "react";
import { Button } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { PENDING_ACCESS_KIND } from "@iso/constants/onboarding";

const describe = ({ kind, property_name: name }) => {
  if (kind === PENDING_ACCESS_KIND.INVITATION) {
    return (
      <>
        You've been invited to <strong>{name}</strong>. Open the invitation
        email to accept it.
      </>
    );
  }
  return (
    <>
      Your {kind === PENDING_ACCESS_KIND.CONTRACTOR ? "contractor " : ""}request to join{" "}
      <strong>{name}</strong> is waiting for the owner to approve it.
    </>
  );
};

// Shown instead of the first step when the user already has memberships
// waiting on someone, so asking to join a property doesn't restart onboarding.
const PendingAccessStep = ({ pending, onFinish, onSetUpSomethingElse }) => (
  <>
    <h1 className="ob-title" tabIndex={-1}>
      Waiting for approval
    </h1>
    <div className="ob-status-list">
      {pending.map((item, index) => (
        <div className="ob-status" key={`${item.property_name}-${index}`}>
          <span className="ob-status-icon" aria-hidden="true">
            <ClockCircleOutlined />
          </span>
          <p>{describe(item)}</p>
        </div>
      ))}
    </div>
    <p className="ob-note">
      The property will appear here as soon as you have access.
    </p>
    <div className="ob-actions">
      <Button className="ob-btn-primary" onClick={onFinish}>
        OK
      </Button>
      <button type="button" className="ob-link" onClick={onSetUpSomethingElse}>
        Set up something else
      </button>
    </div>
  </>
);

export default PendingAccessStep;
